import React, { useState, useEffect } from "react";
import "./Places.css";
import "./PlaceCard/PlaceCard.css";
import PlaceCard from "./PlaceCard/PlaceCard";
// import PlacesHeader from "../PlacesHeader/PlacesHeader";
import store from "../../store/store";
import { useSelector } from "react-redux";
import Common from "../../Common/Common";
import { useDispatch } from "react-redux";
import { slice1Actions } from "../../store/reducer";
//import { useHover } from "usehooks-ts";
//import google_places_logo from "../../assets/images/google-places-logo.jpg";
import SearchResultsBanner from "../SearchResultsBanner";
import LeftoverNamesBanner from "./LeftoverNamesBanner";

const Places = () => {
  // const hoverRef = useRef(null);
  // const isHover = useHover(hoverRef);
  const dispatch = useDispatch();
  const [searchedPlace, setSearchedPlace] = useState("");
  const [places, setPlaces] = useState([]);
  // const [places, setPlaces] = useState([]);

  let arr1 = useSelector((state) => state.places);
  let user_info = useSelector((state) => state.user_info);
  let noFiltering = useSelector((state) => state.noFiltering);
  let LoadingGuide = useSelector((state) => state.LoadingGuide);
  let SearchText = useSelector((state) => state.SearchText);
  let MapBounds = useSelector((state) => state.MapBounds);

    let imageFolder = useSelector((state) => state.imageFolder);

  useEffect(() => {
    // let arr = store
    //   .getState()
    //   .slice()
    let arr = [...arr1];
    // arr = arr.sort(function (a, b) {
    //   return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
    // });

    // let new_arr = [];
    // arr.forEach((section) => {
    //   let new_data = [];
    //   for (let p = 0; p < section.data.length; p++)
    //     new_data.push({ id: section.data[p].id, place: window.guide_obj.places.getPlace(section.data[p]) });
    //   new_arr.push({ Title: section.Title, data: new_data });
    // });

    // console.log("new_arr", new_arr);

    console.log("noFiltering",  noFiltering, "SearchText", SearchText);
    setPlaces([...arr]);
  }, [arr1,noFiltering,SearchText]);
  // places.length > 0 && console.log("Places", places);

  const getImageURLString = (place) => {
    //console.log(`**************getImageURLString, ${place.Name}`);
    //console.log(`Photo:${place.Photo}:, Photo_m:${place.Photo_m}:`);
    //console.log(`Photo_m:${place.Photo_m}:`);
    let str = place.Photo;
    if (str === "" || typeof str === "undefined") str = place.Photo_m;
    let img = Common.getImageURL(str, Common.getFBPath(window.guide_obj.guide_id, user_info), false);
    //if (!img.startsWith("data")) console.log(img);
    //if (img === "google_places_logo") img = google_places_logo;
    //if (!img.startsWith("data:image")) console.log(img);
    return img;
  };

  const sectionClicked = (section) => {
    //console.log("section", section);
    let places = [];
    section.data.forEach((data) => {
      places.push(data.place);
    });
    dispatch(slice1Actions.ClearAllFilters());
    dispatch(slice1Actions.SetPlacesFilter({ value: places }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };
  //console.log("places", places);

  const clearAllFilters = () => {
    dispatch(slice1Actions.ClearAllFilters());
    dispatch(slice1Actions.SetSearchText({ value: "" }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };

    const setImageFolder = (folder) => {
      dispatch(slice1Actions.setImageFolder({ value: folder }));
    };

  // Flatten the currently-displayed sections into an ordered, deduplicated
  // list of place IDs, matching mobile's HTMLViewer `placesList` param — lets
  // Place Details offer Next/Previous through the same order shown here.
  // Category/group-style groupings can repeat the same place across
  // sections, so dedupe by ID.
  const seenPlaceIds = new Set();
  const placesList = [];
  for (const section of places) {
    for (const item of section.data || []) {
      const id = item?.place?.ID;
      if (id == null || seenPlaceIds.has(id)) continue;
      seenPlaceIds.add(id);
      placesList.push(id);
    }
  }

  return (
    <div
      id="PlacesDiv"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        // width: "20%",
        //maxHeight: "100vh",
        overflowY: "auto",
      }}
    >
      <SearchResultsBanner />
      <LeftoverNamesBanner />
      {(!noFiltering || SearchText !== "") && !LoadingGuide ? (
        <div
          onClick={() => clearAllFilters()}
          style={{ background: "#fdcb6e" }}
          className="place-card background-color-yellow"
        >
          <p className="background-color-yellow">Some places may be filtered. Click to show all</p>
        </div>
      ) : null}
      {places.length === 0 && noFiltering && !LoadingGuide && SearchText === "" ? (
        <div className="place-card background-color-yellow">
          <p>No places in guide.</p>
        </div>
      ) : null}
      {places.map((_section) => (
        <div key={_section.Title}>
          <div onClick={() => sectionClicked(_section)} style={{ cursor: "pointer" }}>
            <p className="alpha-order">{_section.Title}</p>
          </div>
          {/* <div onClick={() => sectionClicked(_section);}>
            <p className="alpha-order">{_section.Title}</p>
          </div> */}
          {_section.data.map((_place) => (
            <PlaceCard
              id={`PlaceCard${_place.place.ID}`}
              // ref={hoverRef}
              // Stable per-place key (was array index) — an index-based key
              // meant React matched DOM nodes by POSITION, not identity, so
              // adding a search result (which re-sorts the whole list into
              // alphabetical order, same as mobile) tore down and reassigned
              // every row below the change instead of relocating just the
              // one that moved. That's the "swap the DOM node out from
              // under the cursor" disruption PlaceCard.js's handleAddToGuide
              // already works around for hover state — the reflow itself
              // was the real bug. Mobile's SectionList already keys off
              // item.place.ID (a stable identity) and doesn't have this
              // issue. Found 2026-09-07 — user reported added places
              // appearing to "disappear" (they were just relocated, but the
              // reflow made it look like removal).
              key={_place.place.ID}
              name={_place.place.Name}
              rating={_place.place.Rating}
              groups={window.guide_obj == null ? "" : window.guide_obj.groupNamesFromIDs(_place.place.Group)}
              distance={_place.place.Distance}
              category={window.guide_obj == null ? "" : window.guide_obj.categoryNamesFromIDs(_place.place.Category)}
              img={getImageURLString(_place.place)}
              place={_place.place}
              i={_place.place.ID}
              user_info={user_info}
              map_bounds={MapBounds}
          folder={imageFolder}
          setImageFolder={setImageFolder}
          placesList={placesList}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default Places;
